import React from "react";
import "hammerjs";
import { has } from "lodash";
import useStyles from "./styles";
import {
  Chart,
  ChartLegend,
  ChartSeries,
  ChartSeriesItem,
  ChartSeriesLabels,
  ChartArea,
  ChartTooltip,
  ChartSeriesItemTooltip,
} from "@progress/kendo-react-charts";
import { useTranslation } from "react-i18next";

const DonutCenterRenderer = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <span className={`${classes.donutSummary} donut-summary`}>
      <h4 className="font-bold">{props.allTargetsCount}</h4>
      <h2 className="font-regular">
        {props.centerText ? props.centerText : t("userDashboardReport.targets")}
      </h2>
    </span>
  );
};

const DonutChart = (props) => {
  const classes = useStyles();

  // const labelContent = (e) => {
  //   if (has(e.dataItem, "labelText")) return e.dataItem.labelText;
  //   return `${e.dataItem.targetName} \n ${e.dataItem.count}(${Number(
  //     e.dataItem.percentage
  //   ).toFixed()}%)`;
  // };

  const labelContent = (e) => {
    if (has(e.dataItem, "labelText")) return e.dataItem.labelText;
    return `${e.dataItem.count} (${Number(e.dataItem.percentage).toFixed()}%)`;
  };

  const nestedTooltipRender = (data) => {
    let tooltipText = "";
    if (data.point) {
      tooltipText = `${data.point.dataItem.targetName} (${data.point.dataItem.count})`;
      if (has(data.point.dataItem, "labelTooltip"))
        tooltipText = data.point.dataItem.labelTooltip;
    }

    return <span>{data.point && <span>{tooltipText}</span>}</span>;
  };

  return (
    <div className={`${classes.donutChart} donut-chart`}>
      <Chart
        transitions={true}
        onSeriesClick={(e) => {
          props.setSelectedTarget(e.dataItem.targetType);
        }}
        donutCenterRender={() => (
          <DonutCenterRenderer
            allTargetsCount={props.allTargetsCount}
            centerText={props.centerText}
          />
        )}
      >
        <ChartTooltip />
        <ChartArea background="transparent" />
        <ChartSeries>
          <ChartSeriesItem
            type="donut"
            explodeField="explode"
            holeSize={props.holeSize}
            data={props.data}
            categoryField="targetType"
            field="count"
            startAngle={180}
          >
            <ChartSeriesLabels
              position="outsideEnd"
              background="none"
              content={labelContent}
            />
            <ChartSeriesItemTooltip
              render={nestedTooltipRender}
              background="#eee"
            />
          </ChartSeriesItem>
        </ChartSeries>
        <ChartLegend visible={false} />
      </Chart>
    </div>
  );
};
export default DonutChart;
